export default __webpack_public_path__ + "static/media/640.aba975d1.png";